<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kq4uKD/tc-custom/9781504094351.jpg?1716663322230" alt="This image is the cover for the book Detective Samantha Freeman Cases Books One to Three"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Detective Samantha Freeman Cases Books One to Three
      </h1>
      <p class="bookDescription body article font2">
        <b>Three heart-pounding crime thrillers in one volume from the author of <i>The Accident</i>. </b><br/><br/><b><i>The Shape of Truth</i></b><br/> When Anna learns that her biological father is a member of Parliament who assaulted her mother—and was never held accountable—she’s devastated. She’s determined to bring him to justice. But exposing the truth may bring tragic results . . .<br/><br/><b><i>The Charcoal House</i></b><br/> Emma’s new husband is isolating her from her friends and parents. He takes her paycheck, gaslights her, and forbids her to paint. She manages to complete one picture—of a depressing charcoal house. As shocking revelations about his past emerge, the police and Emma’s loved ones try to free her from a monster’s clutches—but is it already too late to save her?<br/><br/><b><i>The Dead Husband</i></b><br/> At the police station, a woman reports that her husband has disappeared, and soon afterward a body is found. It looks like a hit-and-run case, an accident. But the body is not the missing man’s—and the death was not an accident. Now DI Samantha Freeman must figure out what happened—and to whom . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gillian Jackson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e51bcab